import script from "./totalCard.vue?vue&type=script&setup=true&lang=js"
export * from "./totalCard.vue?vue&type=script&setup=true&lang=js"

import "./totalCard.vue?vue&type=style&index=0&id=8aebada4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8aebada4"]])

export default __exports__